<i [innerHtml]="svgIcon"></i>
